<template>
  <nav-bar
    title="监管企业统计"
  />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading(stId)"
    />
    <div class="total-info">
      <span>区域名称：{{ objData.stName }}</span>
      <span>用户总数：{{ objData.allNum }}</span>
    </div>
    <div class="total-info">
      <span>合法用户数：{{ objData.legalNum }}</span>
      <span>非法用户数：{{ objData.noLegalNum }}</span>
    </div>
    <div class="btn">
      <van-button type="primary" block @click="handleExportClick">导出监管企业</van-button>
    </div>
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.regionCode">
        <span>{{ item.regionName }}:</span>
        <span
          class="item-link"
          :style="{ 'text-decoration': item.reNum > 0 ? 'underline' : '' }"
          @click="handleNumClick(item)"
        >
          {{ item.reNum }}
        </span>
        <span>合法：{{ item.legalNum }}</span>
        <span>非法：{{ item.noLegalNum }}</span>
      </li>
    </ul>
  </Content>
  <Popup title="导出监管企业" minHeight="100%" ref="popup">
    <van-form @submit="onSubmit">
        <van-field
          v-model="email"
          name="recvMail"
          label="邮箱"
          placeholder="邮箱"
          :rules="[{ required: true, message: '请填写邮箱' }, {pattern: /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/, message: '请填写正确邮箱格式'}]"
        />
      <div class="btn">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="submit"
        >
          发送
        </van-button>
      </div>
    </van-form>
  </Popup>
</template>

<script>
import { Notify } from 'vant'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { StatisticsCustomerSupervisionByRegion, exportCustomer } from '@/api/superviseHome'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
export default {
  name: 'SuperviseUser',
  setup() {
    const router = useRouter()
    const objData = ref({})
    const list = ref([])
    const store = useStore()
    const stId = ref('')
    const companyId = computed(() => store.state.roleInfo.companyId)
    const streetLevel = computed(() => store.state.roleInfo.streetLevel)
    const streetName = computed(() => store.state.roleInfo.streetName)
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    stId.value = companyId.value
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      StatisticsCustomerSupervisionByRegion,
      data => {
        objData.value = data
        list.value = data.infoList
      }
    )
    if (streetLevel.value >= 5) {
      router.push(`/superviseUserList/${streetName.value}/${companyId.value}`)
    } else {
      getDataLoading({ stId: stId.value, tenantId: tenantId.value })
    }

    const handleNumClick = ({ level, regionCode, regionName }) => {
      if (level < 5) {
        stId.value = regionCode
        getDataLoading({ stId: stId.value, tenantId: tenantId.value })
      } else {
        router.push(`/superviseUserListForSup/${regionName}/${regionCode}`)
      }
    }
    const goBack = () => {
      stId.value = companyId.value
      getDataLoading({ stId: stId.value, tenantId: tenantId.value || '' })
    }
    const popup = ref(null)
    const email = ref('')
    const handleExportClick = () => {
      popup.value.showPopup()
    }
    const loading = ref(false)
    const onSubmit = (value) => {
      const params = { ...value, stId: stId.value, tenantId: tenantId.value || '' }
      loading.value = true
      exportCustomer(params).then(() => {
        loading.value = false
        popup.value.hidePopup()
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => {
        loading.value = false
      })
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      objData,
      list,
      stId,
      handleNumClick,
      goBack,
      handleExportClick,
      popup,
      email,
      onSubmit,
      loading,
      tenantId
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  margin: 16px;
}
.total-info {
  padding: 16px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.list {
  padding: 0 16px;
  .list-item {
    background: #fff;
    font-size: 16px;
    padding: 10px 5px;
    margin-bottom: 10px;
    span:first-child {
      margin-right: 0;
     }
     span:nth-child(2) {
      font-size: 14px;
     }
    span {
      margin-right: 10px;
      font-size: 12px;
    }
    .item-link {
      color: blue;
      padding-left: 10px;
    }
  }
}
</style>
